var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowBottomPrice)?_c('div',{staticClass:"low-price-box",class:{ mobile: _vm.mobile }},[_vm._v(_vm._s(_vm.bottomPriceTip))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }